import { React, Component, Container, _ } from 'utils';
import { App, InfoStore, Creators } from 'model';
import './infobox.less';

class InfoBox extends Component {

	static getStores() {
		return [InfoStore];
	}

	static calculateState() {
		return {
			visible: InfoStore.isInfoVisible(),
			enabled: InfoStore.getState().enabled,
			content: InfoStore.getContent()
		}
	}

	handleAccept = () => {
		Creators.setInfoVisible(false);
	}

	handleClose = () => {
		Creators.setInfoVisible(false);
		this.setState({ visible: false });
	}

	componentDidMount() {
		this.setup();
	}

	setup() {
		var { visible } = this.state;

		if(visible) {
			$(this.box).addClass('visible');
		} else {
			$(this.box).removeClass('visible');
		}
	}

	componentDidUpdate() {
		this.setup();
	}

	setBoxRef = (box) => {
		this.box = box;
	}

	render() {

		var {content, enabled} = this.state;

		if (!enabled)
		{
			return null;
		}

		var src = App.resourceUrl('close.svg');
		var css = ['infobox'];

		return <div ref={ this.setBoxRef } className={ css.join(' ') }>
			<div className="menu">
				<nav className="navbar navbar-expand-lg navbar-light bg-light">
					<div className="items"><img className="close" onClick={ this.handleClose } src={ src } /></div>
				</nav>
			</div>
			<div className="container-fluid">
				<div className="container">

					<div className="card">
						<div className="card-body">
							<div dangerouslySetInnerHTML={{ __html: content }} ></div>
							<div className="text-center">
								<span className="btn btn-primary" onClick={this.handleAccept}>{_('Continue')}</span>
							</div>
						</div>
					</div>

				</div>

			</div>
		</div>
	}
}

export default Container.create(InfoBox);


// WEBPACK FOOTER //
// ./src/modules/components/infobox.js